import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppResourcePlaning extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("assignmentTypesDS", NotEditableData)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("articleGridOptions", DataGridOptions)
        .addStateImplementation("documentsToBeSendGridOptions", DataGridOptions)
        .addStateImplementation("machineGridOptions", DataGridOptions)
        ;
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", MachineAppTranslations);
    public data: MachineAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class MachineAppTranslations extends propertyTypes.Serializable {
    private Ressource_Ressource = new propertyTypes.TranslatableTextProperty("Ressource.Ressource", "Ressource.Ressource");
    private Einsatz_Container = new propertyTypes.TranslatableTextProperty("Einsatz.Container", "Einsatz.Container");
    private Standard_Msg_SpeichernErfolgreich = new propertyTypes.TranslatableTextProperty("Standard.Msg.SpeichernErfolgreich", "Standard.Msg.SpeichernErfolgreich");
    private Projekt_Projektplanung = new propertyTypes.TranslatableTextProperty("Projekt.Projektplanung", "Projekt.Projektplanung");
    private Beleg_Zeiten = new propertyTypes.TranslatableTextProperty("Beleg.Zeiten", "Beleg.Zeiten");
    private WebSMS_ServiceReport_ServiceReports = new propertyTypes.TranslatableTextProperty("WebSMS.ServiceReport.ServiceReports", "WebSMS.ServiceReport.ServiceReports");
    private WebSMS_ResourcePlanning_AssignmnetTimeZone = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.AssignmnetTimeZone", "WebSMS.ResourcePlanning.AssignmnetTimeZone");
    private WebSMS_ResourcePlanning_UserTimeZone = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.UserTimeZone", "WebSMS.ResourcePlanning.UserTimeZone");
    private WebSMS_ResourcePlanning_ResourceTimeZone = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ResourceTimeZone", "WebSMS.ResourcePlanning.ResourceTimeZone");
    private WebSMS_ResourcePlanning_ToggleTimeZoneTimes = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ToggleTimeZoneTimes", "WebSMS.ResourcePlanning.ToggleTimeZoneTimes");
    private WebSMS_ResourcePlanning_ShouldResetApproval = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ShouldResetApproval", "WebSMS.ResourcePlanning.ShouldResetApproval");
    private WebSMS_ResourcePlanning_ShouldIncreaseApproval = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ShouldIncreaseApproval", "WebSMS.ResourcePlanning.ShouldIncreaseApproval");
    private WebSMS_ResourcePlanning_CannotSaveApprovalRequired = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.CannotSaveApprovalRequired", "WebSMS.ResourcePlanning.CannotSaveApprovalRequired"); private Standard_Neu = new propertyTypes.TranslatableTextProperty("Standard.Neu", "Standard.Neu");
    private Standard_Editieren = new propertyTypes.TranslatableTextProperty("Standard.Editieren", "Standard.Editieren");
    private Standard_Loeschen = new propertyTypes.TranslatableTextProperty("Standard.Loeschen", "Standard.Loeschen");
    private Standard_Msg_Loeschen = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private Einsatz_ArtikelZumEinsatz = new propertyTypes.TranslatableTextProperty("Einsatz.ArtikelZumEinsatz", "Einsatz.ArtikelZumEinsatz");
    private WebSMS_ResourcePlanning_DocumentsToBeSendUpdated = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.DocumentsToBeSendUpdated", "WebSMS.ResourcePlanning.DocumentsToBeSendUpdated");
    private WebSMS_ResourcePlanning_FolgendeEinsaetze = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.FolgendeEinsaetze", "WebSMS.ResourcePlanning.FolgendeEinsaetze");
    private WebSMS_ResourcePlanning_WaehleEinsaetze = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.WaehleEinsaetze", "WebSMS.ResourcePlanning.WaehleEinsaetze");
    private WebSMS_ResourcePlanning_VerschiebenEinsatz = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.VerschiebenEinsatz", "WebSMS.ResourcePlanning.VerschiebenEinsatz");
    private WebSMS_ResourcePlanning_NichtVerschiebenEinsatz = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.NichtVerschiebenEinsatz", "WebSMS.ResourcePlanning.NichtVerschiebenEinsatz");
    private WebSMS_ResourcePlanning_ProjektNichtVerschoben = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ProjektNichtVerschoben", "WebSMS.ResourcePlanning.ProjektNichtVerschoben");
    private GeoMap_NoApiKey = new propertyTypes.TranslatableTextProperty("GeoMap.NoApiKey", "GeoMap.NoApiKey");
    private WebSMS_Messages_PleaseEnterValidDateTimes = new propertyTypes.TranslatableTextProperty("WebSMS.Messages.PleaseEnterValidDateTimes", "WebSMS.Messages.PleaseEnterValidDateTimes");
    private GeoMap_RouteNotFound = new propertyTypes.TranslatableTextProperty("GeoMap.RouteNotFound", "GeoMap.RouteNotFound");
    private WebSMS_ServiceReport_AddMachine = new propertyTypes.TranslatableTextProperty("WebSMS.ServiceReport.AddMachine", "WebSMS.ServiceReport.AddMachine");
    private Projekt_Material = new propertyTypes.TranslatableTextProperty("Projekt.Material", "Projekt.Material");
    private Einsatz_MaterialRegistration = new propertyTypes.TranslatableTextProperty("Einsatz.MaterialRegistration", "Einsatz.MaterialRegistration");
    private Einsatz_SelectedAmount = new propertyTypes.TranslatableTextProperty("Einsatz.SelectedAmount", "Einsatz.SelectedAmount");
    private Einsatz_AvailableAmount = new propertyTypes.TranslatableTextProperty("Einsatz.AvailableAmount", "Einsatz.AvailableAmount");
    private Einsatz_AllocateMaterial = new propertyTypes.TranslatableTextProperty("Einsatz.AllocateMaterial", "Einsatz.AllocateMaterial");
    private WebSMS_GeneralSettings_Project_Status_NoAssignmentGenerationAllowed = new propertyTypes.TranslatableTextProperty("WebSMS.GeneralSettings.Project.Status.NoAssignmentGenerationAllowed", "WebSMS.GeneralSettings.Project.Status.NoAssignmentGenerationAllowed");
    private Einsatz_Rebook_Umbuchen = new propertyTypes.TranslatableTextProperty("Einsatz.Rebook.Umbuchen", "Einsatz.Rebook.Umbuchen");
    private Field_Einsatz_kennung = new propertyTypes.TranslatableTextProperty("Field.Einsatz.kennung", "Field.Einsatz.kennung")
    private Field_Einsatz_projnr = new propertyTypes.TranslatableTextProperty("Field.Einsatz.projnr", "Field.Einsatz.projnr");
    private Standard_PflichtfeldAllgemein = new propertyTypes.TranslatableTextProperty("Standard.PflichtfeldAllgemein", "Standard.PflichtfeldAllgemein");
    private Einsatz_Rebook_RebookOnProject = new propertyTypes.TranslatableTextProperty("Einsatz.Rebook.RebookOnProject", "Einsatz.Rebook.RebookOnProject");
    private Einsatz_Rebook_RebookOnAnotherProject = new propertyTypes.TranslatableTextProperty("Einsatz.Rebook.RebookOnAnotherProject", "Einsatz.Rebook.RebookOnAnotherProject");
    private WebSMS_ResourcePlanning_ChangeAddress = new propertyTypes.TranslatableTextProperty("WebSMS.ResourcePlanning.ChangeAddress", "WebSMS.ResourcePlanning.ChangeAddress");
    private Adresse_Adresse = new propertyTypes.TranslatableTextProperty("Adresse.Adresse", "Adresse.Adresse");
    private Adresse_Adresssuche = new propertyTypes.TranslatableTextProperty("Adresse.Adresssuche", "Adresse.Adresssuche");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Ressource_Ressource, this.Einsatz_Container, this.Standard_Msg_SpeichernErfolgreich,
        this.Projekt_Projektplanung, this.Beleg_Zeiten, this.WebSMS_ServiceReport_ServiceReports, this.WebSMS_ResourcePlanning_AssignmnetTimeZone,
        this.WebSMS_ResourcePlanning_UserTimeZone, this.WebSMS_ResourcePlanning_ResourceTimeZone, this.WebSMS_ResourcePlanning_ToggleTimeZoneTimes,
        this.WebSMS_ResourcePlanning_ShouldResetApproval, this.WebSMS_ResourcePlanning_ShouldIncreaseApproval, this.WebSMS_ResourcePlanning_CannotSaveApprovalRequired,
        this.Standard_Neu, this.Standard_Editieren, this.Standard_Loeschen,
        this.Standard_Msg_Loeschen, this.Einsatz_ArtikelZumEinsatz, this.Einsatz_ArtikelZumEinsatz, this.WebSMS_ResourcePlanning_DocumentsToBeSendUpdated,
        this.WebSMS_ResourcePlanning_FolgendeEinsaetze, this.WebSMS_ResourcePlanning_WaehleEinsaetze, this.WebSMS_ResourcePlanning_VerschiebenEinsatz,
        this.WebSMS_ResourcePlanning_NichtVerschiebenEinsatz, this.WebSMS_ResourcePlanning_ProjektNichtVerschoben,
        this.GeoMap_NoApiKey, this.WebSMS_Messages_PleaseEnterValidDateTimes, this.GeoMap_RouteNotFound, this.WebSMS_ServiceReport_AddMachine, this.Projekt_Material,
        this.Projekt_Material, this.Einsatz_MaterialRegistration, this.Einsatz_SelectedAmount, this.Einsatz_AvailableAmount, this.Einsatz_AllocateMaterial,
        this.WebSMS_GeneralSettings_Project_Status_NoAssignmentGenerationAllowed, this.Einsatz_Rebook_Umbuchen, this.Field_Einsatz_kennung, this.Field_Einsatz_projnr,
        this.Standard_PflichtfeldAllgemein, this.Einsatz_Rebook_RebookOnProject, this.Einsatz_Rebook_RebookOnAnotherProject, this.WebSMS_ResourcePlanning_ChangeAddress,
        this.Adresse_Adresse, this.Adresse_Adresssuche


        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}

class NotEditableData extends propertyTypes.Serializable {
    private dataMetadata = new propertyTypes.NotEditableProperty("data", "Data");
    public data: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata = [this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}